import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Constants } from '../core/constants/constants';
import { Layout } from '../core/classes/layout';
import { ILayout } from '../core/models/layout.vm';
import { IProductListItem } from '../core/models/product-list-item.vm';
import { LoaderService } from '../core/services/loader.service';
import { ProductService } from '../core/services/product.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit, OnDestroy {
  public loadingError: string = null;
  public products: Array<IProductListItem> = [];
  public filteredProducts: Array<IProductListItem> = [];
  public searchTerm: string = '';
  public currentProduct: number;
  public currentUrlParams: any;
  public currentYear: number;
  public layout: ILayout;

  public darkMode$: Observable<boolean>;
  private unsubscribe = new Subject();

  constructor(
    public loaderService: LoaderService,
    private router: Router,
    private route: ActivatedRoute,
    private productService: ProductService,
    private store: Store<{ darkMode: boolean }>
  ) {
    this.darkMode$ = store.select('darkMode');
  }

  ngOnInit(): void {
    this.getOptions();
    this.route.params.pipe(takeUntil(this.unsubscribe)).subscribe((params) => {
      this.currentUrlParams = params;
      this.routeChange(params);
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  routeChange(params): void {
    this.currentProduct = params.id;
    this.currentYear = params.year || Constants.currentYear;
    this.layout = new Layout(
      'Products',
      [], ''
    );
  }

  public getOptions(): void {
    this.productService.getOrganisationProductOptions().pipe(takeUntil(this.unsubscribe)).subscribe(
      success => {
        this.products = (success.data.availableProductList || [])
          .slice()
          .sort((a, b) => a.productName.localeCompare(b.productName));
        this.applySearch();
      },
      error => {
        this.loadingError = 'Unable to load the product list. Please try again.';
        console.log('Error: ', error);
      }
    );
  }

  public applySearch(): void {
    const term = (this.searchTerm || '').trim().toLowerCase();
    this.filteredProducts = !term
      ? this.products
      : this.products.filter(product =>
          product.productName.toLowerCase().includes(term) ||
          (product.productAlias || '').toLowerCase().includes(term)
        );
  }

  public clearSearch(): void {
    this.searchTerm = '';
    this.applySearch();
  }

  public yearChange(year: number): void {
    this.currentYear = year;
    this.router.navigate(['products', this.currentYear]);
  }

  openProduct(product: IProductListItem): void {
    this.router.navigate(['products', this.currentYear, product.productId]);
  }

  public trackByProductId(index: number, product: IProductListItem): number {
    return product.productId;
  }

}
